module.exports = __webpack_public_path__ + "img/code-html-xs.35d0932e.webp";